import get from "lodash/get";
import { LocalizedProperty } from "myfitworld-model";

export function getLocalizedDescription(
  property?: LocalizedProperty,
  locale?: string
): string {
  if (!property) return "";

  let raw = "";

  // 1. Pokušaj sa traženim jezikom
  if (locale) {
    raw = get(property, locale) as string;
  }

  // 2. Ako traženi jezik nije popunjen, fallback na "en"
  if (!raw || raw.trim() === "") {
    raw = get(property, "en") as string;
  }

  // 3. Ako ni "en" nije popunjen, uzmi PRVI jezik koji ima sadržaj
  if (!raw || raw.trim() === "") {
    const firstAvailable = Object.values(property).find(
      (value) => typeof value === "string" && value.trim() !== ""
    );

    raw = firstAvailable || "";
  }

  if (!raw) return "";

  // 4. Detekcija HTML-a (Quill)
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(raw);

  if (isHtml) {
    return raw; // već je HTML
  }

  // 5. Plain text → konverzije
  return raw
    .replace(/\n/g, "<br>")
    .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
}
